import React from "react";
import "./details.css";
import Location from "../../../../assets/images/pin.png";
import mail from "../../../../assets/images/email-con.png";
//hi hi
const Details = () => {
  return (
    <>
      <div className="container mt-5 mb-5">
        <div className="row">
          <div className="col-md-6">
            <div className="detail-card">
              <div className="content-card">
                <img src={Location} alt="location" />
                <p className="loc-title">Location</p>
                <p className="loc-detils">
                  Flat 2, Belvoir Court, 68 Kenton Road, Harrow HA3 8AB
                </p>
              </div>
            </div>
          </div>
          {/* <div className="col-md-4">
            <div className="detail-card">
              <div className="content-card">
                <img src={Location} alt="location" />
                <p className="loc-title">Location</p>
                <p className="loc-detils">
                  P NO 300, TRANSPORT NAGAR, PTC POST, PAPPANODAI, MADURAI
                  POSTAL TRAINING CENTRE, TAMILNADU - 625022
                </p>
              </div>
            </div>
          </div> */}
          <div className="col-md-6">
            <div className="detail-card">
              <div className="content-card">
                <img src={mail} alt="location" />
                <p className="loc-title">Email</p>
                <p className="loc-detils">info@saasphire.co.uk</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Details;
